/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Brain_DescriptionInputs */

const es_common_brain_description = /** @type {(inputs: Common_Brain_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razonamiento avanzado activado. Tu solicitud utilizará un modelo de razonamiento avanzado para un análisis más profundo. Esto consume dos mensajes en lugar de uno.`)
};

const en_common_brain_description = /** @type {(inputs: Common_Brain_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra reasoning is enabled. Your request will use an advanced reasoning model for deeper analysis. This counts as two messages instead of one.`)
};

/**
* | output |
* | --- |
* | "Extra reasoning is enabled. Your request will use an advanced reasoning model for deeper analysis. This counts as two messages instead of one." |
*
* @param {Common_Brain_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_brain_description = /** @type {((inputs?: Common_Brain_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Brain_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_brain_description(inputs)
	return en_common_brain_description(inputs)
});
export { common_brain_description as "common.brain_description" }